module.exports = __webpack_public_path__ + "120336b2cdd2b3ff1819e648653412fc.png";